import React, { useEffect, useState } from 'react'
import DatePicker from 'react-date-picker'
import { connectAffiliate } from './Affiliate.connect'
import { useHistory } from 'react-router'
import moment from 'moment'

const UserReport = ({ actions }) => {
  const history = useHistory()
  const [userType, setUserType] = useState('user')
  const currentDate = new Date()
  const date7DaysAgo = new Date(currentDate.setDate(currentDate.getDate() - 7))
  const [selectedDateFrom, setSelectedDateFrom] = useState(
    new Date(date7DaysAgo)
  )
  const [userList, setUserList] = useState(null)
  const [userDWList, setUserDWList] = useState(null)

  const [selectedDateTo, setSelectedDateTo] = useState(new Date())

  let todayDate = new Date()

  const getMonth = (date) => {
    return `${date.toLocaleDateString('en-GB', {
      month: '2-digit',
    })}`
  }

  const getDate = (date) => {
    return `${date.toLocaleDateString('en-GB', {
      day: '2-digit',
    })}`
  }

  const getAffUserSportWisePL = async () => {
    await actions
      .getAffUserCreatedCountDateWise({
        from_date: selectedDateFrom,
        to_date: selectedDateTo,
      })
      .then((res) => {
        setUserList(res?.data?.data)
      })
      .catch((e) => console.log('', `${e}`))
  }

  const getAffUsersList = async () => {
    await actions
      .getAffUsersList({
        limit: 100,
        page: 1,
        from_date: selectedDateFrom,
        to_date: selectedDateTo,
      })
      .then((res) => {
        if (res?.data?.status) {
          setUserDWList(res?.data)
        }
      })
      .catch((e) => console.log('', `${e}`))
  }

  useEffect(() => {
    if (userType === 'user') {
      getAffUserSportWisePL()
    } else {
      getAffUsersList()
    }
  }, [userType])

  const submit = (e) => {
    e.preventDefault()
    if (userType === 'user') {
      getAffUserSportWisePL()
    } else {
      getAffUsersList()
    }
  }
  return (
    <>
      <form className="typeslabel affiliate_filter openbettss affiliate-pl affiliate-report affi-date-filter-form">
        <div
          className=" account-statement-page__filter-content"
          style={{ maxWidth: '600px' }}
        >
          <div className="account-statement-page__filters-date-input">
            <p>Date from:</p>
            <div>
              <DatePicker
                onChange={setSelectedDateFrom}
                value={selectedDateFrom}
                locale={'en-US'}
                showLeadingZeros={true}
                clearIcon={null}
                calendarIcon={null}
                format={'dd/MM/yyyy'}
                dayPlaceholder={getDate(todayDate)}
                monthPlaceholder={getMonth(todayDate)}
                yearPlaceholder={todayDate.getFullYear()}
              />
            </div>
          </div>
          <div className="account-statement-page__filters-date-input">
            <p>Date to:</p>
            <div>
              <DatePicker
                onChange={setSelectedDateTo}
                value={selectedDateTo}
                locale={'en-US'}
                showLeadingZeros={true}
                clearIcon={null}
                calendarIcon={null}
                format={'dd/MM/yyyy'}
                dayPlaceholder={getDate(todayDate)}
                monthPlaceholder={getMonth(todayDate)}
                yearPlaceholder={todayDate.getFullYear()}
              />
            </div>
          </div>

          <div className="account-statement-page__filters-date-input">
            <p>Type</p>
            <div>
              <select
                onChange={(e) => setUserType(e.target.value)}
                className="select_type_aff"
              >
                <option value="user">User Added</option>
                <option value="dw">Deposit/Withdraw</option>
              </select>
            </div>
          </div>
          <button
            className="account-statement-page__date-search-button"
            onClick={submit}
          >
            <span>Submit</span>
          </button>
        </div>
      </form>
      <div className="nw-affi-user-list-wrapper">
        <div className="table-responsive nw-affi-user-table">
          {userType === 'user' ? (
            <table className="table">
              <thead>
                <tr>
                  <th style={{ textAlign: 'left' }}>Date</th>
                  <th>Users Added</th>
                  <th>Detail</th>
                </tr>
              </thead>
              <tbody style={{ background: '#fff' }}>
                {userList?.length > 0 ? (
                  userList?.map((item) => (
                    <tr className="user_list_tr" key={item?.date}>
                      <td className="text-left">{item?.date}</td>
                      <td className="text-center">{item?.count}</td>
                      <td className="text-center">
                        <button
                          className="thm-but btn-gradient user_list_btn"
                          onClick={() => history.push('/affiliate/users-list')}
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={3} className="text-center text-sm p-2">
                      No Records Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          ) : (
            <table className="table bg-bg_light" style={{ background: '#fff' }}>
              <thead>
                <tr className="bg-bg_Secondary">
                  <th className="text-left py-2 px-1 text-white">Date</th>
                  <th className="text-center py-2 px-1 text-white">
                    User Name
                  </th>
                  <th className="text-center py-2 px-1 text-white">Balance</th>
                  <th className="text-center py-2 px-1 text-white text-nowrap">
                    DW Report
                  </th>
                </tr>
              </thead>
              <tbody>
                {userDWList?.data?.length > 0 ? (
                  userDWList?.data?.map((item) => (
                    <tr className="user_list_tr" key={item?.date}>
                      <td className="text-left text-nowrap">
                        {' '}
                        {moment(item?.createdAt).format('DD/MM/YYYY hh:mm A')}
                      </td>
                      <td className="text-center">{item?.user_name}</td>
                      <td className="text-center">{item?.balance}</td>
                      <td className="text-center">
                        <button
                          onClick={() => history.push(`/account_statement/${item?._id}/1`)}
                          className="thm-but btn-gradient user_list_btn"
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4} className="text-center text-sm p-2">
                      No Records Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </>
  )
}

export default connectAffiliate()(UserReport)
